import { render, staticRenderFns } from "./accountSidebar.vue?vue&type=template&id=33187c68&scoped=true&"
import script from "./accountSidebar.vue?vue&type=script&lang=js&"
export * from "./accountSidebar.vue?vue&type=script&lang=js&"
import style0 from "./accountSidebar.vue?vue&type=style&index=0&id=33187c68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33187c68",
  null
  
)

export default component.exports